import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User deleted a context field',
  name: 'context_field_deleted',
  params: [
    {
      description: 'The source of the deletion',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['manual'],
    },
    {
      description: 'The name of the field',
      name: 'field_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
